<template>
  <div class="audioconverter-view">

    <!-- 软件落地页的子标题栏 -->
    <div class="soft-page-header-wrapper white-theme" id="soft-page-header">
      <div class="soft-page-header-content">
        <div class="soft-page-header-left">
          <div class="soft-page-header-left-gname">
            <img :src="szSoftIconUrl" alt="">
            <h1>{{szSoftName}}</h1>
          </div>
        </div>

        <div class="soft-page-header-right">
          <div class="soft-page-header-right-download">
            <a class="secondary-download-outer-btn" href="javascript:void(0)" @click.left="Util.DownloadButtonClicked(szSoftPackageUrl)">
              <img src="/images/softs/iconWin.svg" alt="">
              <span>立即下载</span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="soft-page-content-wrapper">

      <div class="banner">
        <div class="banner-content">
          <div class="banner-left">
            <div class="banner-soft-tag">
              <span>{{iYEAR}}全新版</span>
            </div>

            <h2 class="banner-soft-name">{{szSoftName}}</h2>
            <p class="banner-soft-description">
              一站式解决音乐格式转换、海量格式任意转换，无损音质处理，让多媒体处理更简单。
            </p>

            <div class="banner-soft-download">
              <a class="banner-soft-download-btn" href="javascript:void(0)" @click.left="Util.DownloadButtonClicked(szSoftPackageUrl)">
                <img src="/images/softs/iconWinForBanner.svg" alt="">
                免费下载
              </a>
            </div>

            <p class="banner-soft-supported-sys"><span>适用系统：win7/win8/win10/win11</span></p>
            <p class="banner-soft-update-date"><span>更新时间：{{szSoftUpdateDate}}</span></p>
          </div>

          <div class="banner-right">
            <img src="/images/softs/audioconverter/iconBannerProduct.png" alt="">
          </div>
        </div>

        <div class="banner-bottom">
          <img src="/images/softs/audioconverter/iconBannerComment.png" alt="">
          <div class="banner-bottom-content">
            <span>评分：4.8/5</span>
            <span>来自10,000+用户的好评</span>
          </div>
        </div>
      </div>

      <!-- 产品特性 -->
      <div class="feature-wrapper">
        <h3>一键转换，便捷体验</h3>
        <span>{{szSoftName}}，融合先进智能技术，为您提供前所未有的多媒体处理体验</span>
        <ul>
          <template v-for="{title, text, iconUrl} in stFeatures">
            <li>
              <div class="feature-icon">
                <img :src="iconUrl" alt="">
              </div>
              <p>{{title}}</p>
              <span>{{text}}</span>
            </li>
          </template>
        </ul>
      </div>

      <!-- 支持格式 -->
      <div class="supported-formats-wrapper">
        <h3>全面支持各种音频格式</h3>
        <span>无论您需要导入什么格式，我们都能满足，让您的音频在任何设备上都能流畅播放</span>
        <div class="supported-audio-formats-list">
          <p>音频格式</p>
          <ul>
            <template v-for="{title, text} in stSupportedAudioFormats">
              <li>
                {{title}}
                <span>{{text}}</span>
              </li>
            </template>
          </ul>
        </div>
      </div>

      <div class="use-steps-wrapper">
        <h3>简单三步，完成处理</h3>
        <span>无需专业知识，任何人都能轻松上手，快速完成音频格式转换与编辑</span>
        <div class="use-steps-wrapper-content">
          <div class="use-steps-tabs">
            <template v-for="(item, idx) in stUseSteps">
              <div class="use-steps-item" :class="{'active': iCurUseStepIdx == idx}"
                @mouseenter="EnterUseStepItem($event, idx)" @mouseleave="LeaveUseStepItem($event, idx)"
              >
                <p>{{String(idx + 1).padStart(2, '0')}}</p>
                <div class="use-steps-item-text">
                  <span>{{item.title}}</span>
                  <span>{{item.text}}</span>
                </div>
              </div>
            </template>
          </div>
          <div class="use-steps-item-imgs">
            <template v-for="(item, idx) in stUseSteps">
              <img :src="item.imageUrl" :class="{'active': iCurUseStepIdx == idx}">
            </template>
          </div>
        </div>
      </div>

      <!-- 用户评价 -->
      <div class="user-quotes-wrapper">
        <h3>用户的真实评价</h3>
        <span>来自各行各业的用户对我们产品的真实反馈</span>
        <ul>
          <template v-for="{userHeaderUrl, userName, userJob, text} in stUserQuotes">
            <li>
              <div class="user-quotes-item-title">
                <img :src="userHeaderUrl" alt="">
                <div class="user-quotes-item-name">
                  <p>{{userName}}</p>
                  <span>{{userJob}}</span>
                </div>
                <img src="/images/softs/audioconverter/iconUserQuotes.png" alt="">
              </div>
              <div class="user-quotes-item-content">
                <p>{{text}}</p>
                <img src="/images/softs/audioconverter/commentStars.png" alt="">
              </div>
            </li>
          </template>
        </ul>
      </div>

      <!-- 常见问题 -->
      <div class="questions-wrapper">
        <p>常见问题</p>
        <span>您可能关心的问题，我们都为您准备好了答案</span>
        <ul>
          <template v-for="(item, idx) in stQuestions">
            <li>
              <div class="question-item" :class="{'active': item.activated}" @click.left="OnQuestionItemClicked($event, idx)">
                <p>{{item.question}}</p>
                <img src="/images/softs/audioconverter/iconComboArrow-0.png" alt="">
              </div>
              <div class="question-item-answer" :class="{'active': item.activated}">{{item.answer}}</div>
            </li>
          </template>
        </ul>
      </div>

      <div class="bottom-download-wrapper">
        <img :src="szSoftIconUrl" alt="Viwoo音频格式转换器">
        <p>{{szSoftName}}</p>
        <span>专业音频格式转换器，开启高品质音频处理。</span>
        <a href="javascript:void(0)" @click.left="Util.DownloadButtonClicked(szSoftPackageUrl)">立即体验</a>
        <span>支持 Windows 7/8/10/11</span>
      </div>

    </div>

  </div>
</template>

<style scoped>
.audioconverter-view {
  margin: 0 auto;
  background-color: #FFFFFF;
}

.soft-page-content-wrapper {
  margin-top: 59px;
}

.banner {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 100px;
  padding-bottom: 74px;
  background: url(/images/softs/audioconverter/bgBanner.png) no-repeat center;
  background-size: cover;

  .banner-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 1200px;
    margin: 0 auto;
  }

  .banner-left {
    display: flex;
    flex-direction: column;

    .banner-soft-tag {
      background: url(/images/softs/audioconverter/bgBannerSoftTag.png) no-repeat;
      width: 121px;
      height: 39.75px;
      display: flex;
      justify-content: center;

      span {
        margin-top: 5px;
        color: #fff;
        font-size: 17px;
        font-weight: 700;
      }
    }

    .banner-soft-name {
      color: #1D2129;
      font-family: "Microsoft YaHei UI";
      font-size: 46px;
      font-weight: 700;
      line-height: 70px;
    }

    .banner-soft-description {
      margin: 24px 0 48px 0;
      color: #666;
      font-family: "Microsoft YaHei UI";
      font-size: 20px;
      font-weight: 700;
      line-height: 30px;
    }

    .banner-soft-download {
      .banner-soft-download-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 220px;
        height: 60px;

        cursor: pointer;
        border-radius: 10px;
        background: #19D0B2;
        color: #FFF;
        text-align: center;
        font-size: 20px;

        &:hover {
          background: linear-gradient(270deg, #19D0B2 0%, #49DAB6 100%);
        }

        img {
          margin-right: 16px;
        }
      }
    }

    .banner-soft-supported-sys {
      margin-top: 16px;
      font-size: 14px;
      color: #737373;
    }
    .banner-soft-update-date {
      margin-top: 5px;
      font-size: 14px;
      color: #737373;
    }
  }

  .banner-right {
    img {
      width: 647px;
      height: auto;
    }
  }

  .banner-bottom {
    margin-top: 80px;
    display: flex;
    align-items: center;
    gap: 16px;

    & > img {
      width: 268px;
      height: 60px;
      flex-shrink: 0;
    }
  }

  .banner-bottom-content {
    display: flex;
    flex-direction: column;
    gap: 8px;

    span:first-of-type {
      color: #333;
      font-size: 18px;
      font-weight: 700;
      line-height: 24px;
    }

    span:last-of-type {
      color: #19D0B2;
      font-size: 18px;
      line-height: 20px;
    }
  }
}

.feature-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 100px 0;

  h3 {
    color: #1D2129;
    text-align: center;
    font-size: 36px;
    font-weight: 700;
    line-height: 100%;
  }

  > span {
    margin: 28px 0 90px 0;
    color: #777;
    text-align: center;
    font-size: 20px;
    line-height: 100%;
  }

  ul {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 40px 30px;
    width: 1200px;

    li {
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      width: 380px;
      height: 265px;
      padding: 24px 24px 51px 24px;
      flex-shrink: 0;
      border-radius: 12px;
      border: 1px solid rgba(216, 229, 255, 0.25);
      background: #FEFEFF;
      box-shadow: 0 4px 20px 0 rgba(216, 229, 255, 0.35);
      transition: all 0.3s ease-in-out;
      cursor: pointer;

      &:hover {
        transform: translateY(-10px);
        border-radius: 12px;
        border: 1px solid rgba(216, 229, 255, 0.25);
        background: #F5F8FF;
        box-shadow: 0 4px 20px 0 rgba(216, 229, 255, 0.35);
      }

      .feature-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 68px;
        height: 68px;
        flex-shrink: 0;
        border-radius: 9999px;
        background: rgba(22, 93, 255, 0.08);
      }
      img {
        width: 48px;
        height: 48px;
        flex-shrink: 0;
      }
      p {
        margin: 20px 0;
        color: #333;
        font-size: 24px;
        font-weight: 700;
        line-height: 28px;
      }
      span {
        color: #777;
        font-size: 18px;
        line-height: 150%;
      }
    }
  }

}

.supported-formats-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 100px 0;
  background: linear-gradient(276deg, #E7F9F9 0%, #EFF6FF 41.56%, #E7F9F9 99.41%);

  h3 {
    color: #1D2129;
    text-align: center;
    font-size: 36px;
    font-weight: 700;
    line-height: 100%;
  }

  & > span {
    margin: 28px 0 80px 0;
    color: #777;
    text-align: center;
    font-size: 20px;
    line-height: 100%;
  }

  & > div {
    display: flex;
    flex-direction: column;
    align-items: center;

    p {
      color: #333;
      text-align: center;
      font-size: 26px;
      line-height: 28px;
    }
    ul {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 22px;
      margin-top: 40px;
      width: 1202px;

      li {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        box-sizing: border-box;
        width: 182px;
        height: 92px;
        border: transparent;
        flex-shrink: 0;
        gap: 20px;
        color: #333;
        text-align: center;
        font-size: 24px;
        line-height: 100%;
        border-radius: 12px;
        background: #FFF;
        cursor: pointer;
        transition: all 0.3s ease-in-out;

        &:hover {
          border-radius: 12px;
          border: 1px solid #FFF;
          background: linear-gradient(180deg, #D3FCEC 0%, #D3FCEC 100%);
          color: #19D0B2;

          span {
            color: #19D0B2;
          }
        }

        span {
          color: #777;
          text-align: center;
          font-size: 14px;
          line-height: 100%;
        }
      }
    }
  }
}

.use-steps-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 100px 0;

  h3 {
    color: #1D2129;
    text-align: center;
    font-size: 36px;
    font-weight: 700;
    line-height: 100%;
  }

  & > span {
    margin: 28px 0 100px 0;
    color: #4E5969;
    text-align: center;
    font-size: 20px;
    line-height: 100%;
  }

  .use-steps-wrapper-content {
    display: flex;
    align-items: center;
    width: 1200px;

    .use-steps-tabs {
      display: flex;
      flex-direction: column;
      gap: 20px;
    }

    .use-steps-item {
      display: flex;
      gap: 15px;
      box-sizing: border-box;
      width: 474px;
      height: 128px;
      padding: 15px 30px;
      flex-shrink: 0;
      border-radius: 20px;
      cursor: pointer;

      p {
        color: #5B626B;
        font-family: Arial;
        font-size: 48px;
        font-weight: 700;
      }
      .use-steps-item-text {
        display: flex;
        flex-direction: column;
        gap: 16px;
      }

      span:first-of-type {
        color: #5B626B;
        font-size: 24px;
      }
      span:last-of-type {
        color: #4E5969;
        font-size: 16px;
        line-height: 150%;
      }
    }

    .use-steps-item.active {
      background: linear-gradient(90deg, #E7F9F9 0%, #F0FDFD 100%);

      p {
        font-family: Arial;
        font-size: 48px;
        font-weight: 700;
        background: #19D0B2;
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      span:first-of-type {
        color: #19D0B2;
        font-size: 24px;
      }
    }

    .use-steps-item-imgs {
      margin-left: 80px;
      img {
        display: none;
        width: auto;
        height: 449px;
        flex-shrink: 0;
      }
      img.active {
        display: block;
      }
    }

  }
}

.user-quotes-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 100px 0;
  background: linear-gradient(180deg, #FFF 0%, #F7FAFF 100%);

  h3 {
    color: #1D2129;
    text-align: center;
    font-size: 36px;
    font-weight: 700;
    line-height: 100%;
  }

  & > span {
    margin: 28px 0 100px 0;
    color: #777;
    text-align: center;
    font-size: 20px;
    line-height: 100%;
  }

  ul {
    display: flex;
    align-items: center;
    gap: 21px;
    width: 1200px;

    li {
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      padding: 39px 27px 0 27px;
      width: 386px;
      height: 360px;
      flex-shrink: 0;
      border-radius: 16px;
      background: #FFF;
      box-shadow: 0 4px 20px 0 rgba(216, 229, 255, 0.35);

      .user-quotes-item-title {
        position: relative;
        display: flex;
        align-items: center;
        gap: 15px;
        height: 68px;

        img:first-of-type {
          width: 68px;
          height: 68px;
          flex-shrink: 0;
        }
        img:last-of-type {
          position: absolute;
          right: 0;
          bottom: 23px;
        }

        .user-quotes-item-name {
          display: flex;
          flex-direction: column;
          gap: 16px;

          p {
            color: #333;
            text-align: justify;
            font-size: 20px;
            font-weight: 700;
            line-height: 100%;
          }
          span {
            color: #333;
            text-align: justify;
            font-size: 14px;
            line-height: 100%;
          }
        }
      }

      .user-quotes-item-content {
        display: flex;
        flex-direction: column;
        gap: 40px;
        align-items: center;
        margin-top: 40px;

        p {
          color: #777;
          text-align: justify;
          font-size: 18px;
          line-height: 150%;
        }
      }
    }
  }
}

.questions-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 100px 0;

  & > p {
    color: #1D2129;
    text-align: center;
    font-size: 36px;
    font-weight: 700;
    line-height: 100%;
  }
  & > span {
    margin: 28px 0 100px 0;
    color: #4E5969;
    text-align: center;
    font-size: 20px;
    line-height: 100%;
  }

  ul {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 28px;

    li {
      width: 1200px;

      .question-item {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 27px;
        height: 76px;
        border-radius: 12px 12px 12px 12px;
        border: 1px solid #EEE;
        background: #F7FAFF;

        img {
          height: 24px;
          width: 24px;
          transform: rotate(180deg);
          transition: all 0.3s ease-in-out;
        }
        p {
          color: #333;
          font-size: 22px;
          line-height: 100%;
        }
      }

      .question-item.active {
        border-radius: 12px 12px 0px 0px;
        border-bottom: none;
        img {
          transform: rotate(0deg);
        }
      }

      .question-item-answer {
        height: 0;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        border: 1px solid #EEE;
        border-top: none;
        border-bottom: transparent;
        padding: 0 27px;
        border-radius: 0 0 12px 12px;
        background: #FFF;
        color: #777;
        font-size: 18px;
        line-height: 150%;
        transition: all 0.3s ease-in-out;
        overflow: hidden;
      }
      .question-item-answer.active {
        height: 108px;
        border: 1px solid #EEE;
      }

    }
  }
}


.bottom-download-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 100px 0;
  background: url(/images/softs/audioconverter/bgBottomDownload.png) no-repeat center/cover, linear-gradient(276deg, #E7F9F9 0%, #EFF6FF 41.56%, #E7F9F9 99.41%);

  & > img {
    width: 98px;
    height: 98px;
    flex-shrink: 0;
  }
  & > p {
    margin: 32px 0 24px 0;
    color: #1D2129;
    font-size: 40px;
    font-weight: 700;
    line-height: 60px;
  }
  & > p + span {
    color: rgba(51, 51, 51, 0.9);
    font-size: 24px;
    line-height: 150%;
  }

  a {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    box-sizing: border-box;
    margin: 48px 0 16px 0;
    width: 260px;
    height: 68px;
    border-radius: 34px;
    background: linear-gradient(270deg, #19D0B2 0%, #19D0B2 100%);
    color: #FFF;
    font-size: 24px;
    font-weight: 700;
    line-height: 24px;
  }
  a:hover {
    background: linear-gradient(270deg, #19D0B2 0%, #49DAB6 100%);
  }
  a + span {
    color: #666;
    font-family: Inter;
    font-size: 20px;
    line-height: 20px;
  }
}
</style>

<script lang="ts" setup>
/* definePageMeta()是编译器宏，不用实际代码运行 */
definePageMeta({
})

import * as Vue from 'vue'
import * as VueUse from '@vueuse/core'
import * as Util from '@/util'

const iYEAR = new Date().getFullYear()
const szSoftUpdateDate = (() => {
  /* 当前日期减去15天 */
  const now = Date.now();
  const sevenDaysAgo = now - (15 * 24 * 60 * 60 * 1000);
  const date = new Date(sevenDaysAgo);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
})()

const szSoftName = '易趣音频格式转换器'
const szSoftIconUrl = '/images/softs/audioconverter/appLogo.png'

const szSoftPackageUrl = 'https://gitcode.com/qq_43479262/YQAudioConverter-package/releases/download/v1.1.1/YQAudioConverterMinIns_1.1.1.0_001.exe'

const stFeatures = Vue.ref([
  { title: '全格式转换', text: '支持MP3、FLAC、WAV、AAC、M4A等30+音频格式的相互转换，满足您的各种需求',
    iconUrl: '/images/softs/audioconverter/iconFeature-0.png',
  },
  { title: '多平台支持', text: '支持各大音乐平台的音频文件转换，让音乐自由分享',
    iconUrl: '/images/softs/audioconverter/iconFeature-1.png',
  },
  { title: '无损音质', text: '采用先进的音频编码技术，确保转换过程中音质损失最小化，保留音乐的原始细节',
    iconUrl: '/images/softs/audioconverter/iconFeature-2.png',
  },
  { title: '自动匹配参数', text: '识别音乐文件信息，自动匹配最佳转换参数，保留原始音质与元数据信息',
    iconUrl: '/images/softs/audioconverter/iconFeature-3.png',
  },
  { title: '自定义设置', text: '可自定义比特率、采样率等参数，根据您的需求平衡音质和文件大小',
    iconUrl: '/images/softs/audioconverter/iconFeature-4.png',
  },
  { title: '批量转换', text: '支持多文件批量转换，节省您的时间，提高效率，一次操作处理多个音频文件',
    iconUrl: '/images/softs/audioconverter/iconFeature-5.png',
  },
])

const stSupportedAudioFormats = Vue.ref([
  { title: 'MP3', text: '最流行的音频格式'},
  { title: 'FLAC', text: '无损音频格式'},
  { title: 'WAV', text: '未压缩音频'},
  { title: 'AAC', text: '高效音频编码'},
  { title: 'M4A', text: '苹果音频格式'},
  { title: 'OGG', text: '开源音频格式'},

  { title: 'WMA', text: 'Windows音频'},
  { title: 'AIFF', text: '音频交换文件格式'},
  { title: 'AC3', text: '多声道环绕声格式'},
  { title: 'CAF', text: '苹果数码音频格式'},
  { title: 'MPGA', text: '压缩音频格式'},
  { title: '+30', text: '更多格式支持'},
])

let iCurUseStepIdx = Vue.ref(0)
let iUseStepTimerId = 0
const stUseSteps = Vue.ref([
  {
    title: '添加音频文件',
    text: '点击"添加文件"按钮，或直接将音频文件拖拽到软件窗口中。支持批量添加多个文件。',
    imageUrl: '/images/softs/audioconverter/stepImg-0.png',
  },
  {
    title: '选择功能与参数',
    text: '选择转换格式、提取音频或分割合并功能，可自定义音质、比特率等参数。',
    imageUrl: '/images/softs/audioconverter/stepImg-1.png',
  },
  {
    title: '开始处理',
    text: '点击"开始处理"按钮，等待片刻即可完成。处理速度比传统软件快30%以上。',
    imageUrl: '/images/softs/audioconverter/stepImg-2.png',
  },
])

const stUserQuotes = Vue.ref([
  {
    userHeaderUrl: '/images/softs/audioconverter/head1.png',
    userName: '张先生',
    userJob: '音乐爱好者',
    text: '"用了这款软件来转换音频格式，转换出来的音频格式就是自己想要的音频格式，方便车载音乐播放，很实用！"',
  },
  {
    userHeaderUrl: '/images/softs/audioconverter/head2.png',
    userName: '李女士',
    userJob: '自媒体创作者',
    text: '"这款转换器太好用了！能转换各种音乐格式，音质非常好。批量转换功能帮我整理了整个音乐库。"',
  },
  {
    userHeaderUrl: '/images/softs/audioconverter/head3.png',
    userName: '王老师',
    userJob: '音乐教师',
    text: '"教学中需要用到大量音乐素材，这款软件帮我解决了格式不兼容的问题，统一格式非常方便。"',
  },
])

const stQuestions = Vue.ref([
  {
    question: '这款软件支持哪些操作系统？',
    answer: szSoftName + '支持Windows 7/8/10/11操作系统。',
    activated: false,
  },
  {
    question: '转换后的音乐质量会下降吗？',
    answer: '我们采用先进的音频处理技术，在转换过程中会尽可能保留原始音质。对于无损格式之间的转换（如FLAC转ALAC），可以实现完全无损转换。对于有损压缩格式（如MP3），您可以自定义比特率等参数，平衡音质和文件大小。',
    activated: false,
  },
  {
    question: '购买后可以免费升级吗？',
    answer: '是的，付费用户可以享受终身免费升级服务，包括功能更新和性能优化。我们会不断改进产品，为用户提供更好的体验。',
    activated: false,
  },
  {
    question: '处理速度有多快？',
    answer: '处理速度取决于文件大小、格式和您的电脑配置。在普通电脑上，转换一首5分钟的MP3歌曲大约需要10-20秒，提取一段10分钟的视频音频大约需要30-60秒。我们的加速技术比传统软件快30%-50%，同时，批量处理功能可以进一步提高效率。',
    activated: false,
  },
])

/* 用于动态设置当前页面的标题 */
useHead({
  title: szSoftName + '-专业无损音频格式转换工具',
  link: [
    { rel: 'icon', href: szSoftIconUrl }
  ],
  meta: [
    { charset: 'utf-8' },
    { name: 'viewport', content: 'width=device-width, initial-scale=1.0' },
    { name: 'description', content: szSoftName + '是一款多功能的在线音频转换软件，集合了音频格式转换、音乐格式转换等多种功能，支持mp3/wav/wma/m4r/m4a/ac3/aac/ogg/flac等常见音频音乐格式转换' },
    { name: 'keywords', content: szSoftName + ',音频转换器,MP3转换器,音频转换软件,音频格式转换器,音乐格式转换器,免费软件' },
  ],
})

Vue.onMounted(() => {
  /* 动态设置当前页面的图标，参考：https://stackoverflow.com/questions/77135452/how-to-change-the-favicon-dynamically-in-nuxt-3 */
  /* 对于Nuxt项目，可以使用useHead()，但是好像对于图标来说，只能支持svg? */
  /*   这里使用VueUse.useFavicon设置png */
  VueUse.useFavicon(szSoftIconUrl, {
    rel: 'icon'
  })

  /* 开启定时更新试用步骤的定时器 */
  iUseStepTimerId = setInterval(ChangeToNextUseStep, 3000)
})

Vue.onUnmounted(() => {
})

function ChangeToNextUseStep()
{ iCurUseStepIdx.value = (iCurUseStepIdx.value + 1) % stUseSteps.value.length }
function EnterUseStepItem(evt: MouseEvent, idx: number)
{
  clearInterval(iUseStepTimerId)
  iUseStepTimerId = 0
  iCurUseStepIdx.value = idx
}
function LeaveUseStepItem(evt: MouseEvent, idx: number)
{ iUseStepTimerId = setInterval(ChangeToNextUseStep, 3000) }
function OnQuestionItemClicked(evt: MouseEvent, idx: number)
{
  if(idx < stQuestions.value.length && stQuestions.value[idx])
    stQuestions.value[idx].activated = !stQuestions.value[idx].activated
}
</script>
